import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { AdTopBanner, AdBottomBanner } from '../components/AdSense';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, this would send the form data to a server
    console.log('Form submitted:', formData);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <AdTopBanner />
          
          <nav className="text-sm text-gray-500 mb-4">
            <Link to="/home" className="text-cyan-400 hover:text-cyan-300">Home</Link>
            <span className="mx-2">›</span>
            <span className="text-gray-400">Contact</span>
          </nav>

          <h1 className="text-3xl font-bold text-white mb-6">Contact Us</h1>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
              <h2 className="text-xl font-semibold text-cyan-400 mb-4">Get in Touch</h2>
              
              {submitted ? (
                <div className="bg-green-500/20 border border-green-500/50 rounded-lg p-4 text-green-400">
                  <p className="font-semibold">Thank you for your message!</p>
                  <p className="text-sm mt-1">We'll get back to you as soon as possible.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm text-gray-400 mb-1">Name</label>
                    <Input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="bg-[#0d0d0d] border-[#2a2a2a] text-white"
                      placeholder="Your name"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-400 mb-1">Email</label>
                    <Input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="bg-[#0d0d0d] border-[#2a2a2a] text-white"
                      placeholder="your@email.com"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-400 mb-1">Subject</label>
                    <Input
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="bg-[#0d0d0d] border-[#2a2a2a] text-white"
                      placeholder="What is this about?"
                    />
                  </div>
                  <div>
                    <label className="block text-sm text-gray-400 mb-1">Message</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={5}
                      className="w-full bg-[#0d0d0d] border border-[#2a2a2a] text-white rounded-md p-3 focus:border-cyan-500 focus:outline-none"
                      placeholder="Your message..."
                    />
                  </div>
                  <Button type="submit" className="w-full bg-cyan-600 hover:bg-cyan-500">
                    Send Message
                  </Button>
                </form>
              )}
            </div>

            <div className="space-y-6">
              <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
                <h2 className="text-xl font-semibold text-cyan-400 mb-4">Why Contact Us?</h2>
                <ul className="text-gray-300 space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="text-cyan-400 text-xl">💡</span>
                    <span>Suggest new calculator features</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-cyan-400 text-xl">🐛</span>
                    <span>Report bugs or calculation errors</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-cyan-400 text-xl">❓</span>
                    <span>Ask questions about how to use our calculators</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-cyan-400 text-xl">🤝</span>
                    <span>Partnership or business inquiries</span>
                  </li>
                </ul>
              </div>

              <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6">
                <h2 className="text-xl font-semibold text-cyan-400 mb-4">Quick Links</h2>
                <div className="space-y-2">
                  <Link to="/about" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                    → About Us
                  </Link>
                  <Link to="/sitemap" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                    → All Calculators
                  </Link>
                  <Link to="/privacy" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                    → Privacy Policy
                  </Link>
                  <Link to="/terms" className="block text-gray-300 hover:text-cyan-400 transition-colors">
                    → Terms of Use
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <AdBottomBanner />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
